"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLevel = getCategoryLevel;
exports.getCategoryLevels = getCategoryLevels;
function getCategoryLevel(item) {
    if (!item) {
        return {};
    }
    var categoryId = void 0;
    if (item.categoryId) {
        categoryId = item.categoryId;
    } else {
        categoryId = item.l1CategoryId;
    }

    if (categoryId === item.l1CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l1CategoryLabel,
            categoryName: item.l1CategoryName,
            categoryUrl: item.l1CategoryUrl
        };
    } else if (categoryId === item.l2CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l2CategoryLabel,
            categoryName: item.l2CategoryName,
            categoryUrl: item.l2CategoryUrl
        };
    } else if (categoryId === item.l3CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l3CategoryLabel,
            categoryName: item.l3CategoryName,
            categoryUrl: item.l3CategoryUrl
        };
    } else if (categoryId === item.l4CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l4CategoryLabel,
            categoryName: item.l4CategoryName,
            categoryUrl: item.l4CategoryUrl
        };
    }
}

function getCategoryLevels(item) {
    var collection = [];

    if (!item) {
        return collection;
    }

    collection.push({
        categoryId: item.l1CategoryId,
        categoryLabel: item.l1CategoryLabel,
        categoryName: item.l1CategoryName,
        categoryUrl: item.l1CategoryUrl
    });

    if (item.l2CategoryId) {
        collection.push({
            categoryId: item.l2CategoryId,
            categoryLabel: item.l2CategoryLabel,
            categoryName: item.l2CategoryName,
            categoryUrl: item.l2CategoryUrl
        });
    }

    if (item.l3CategoryId) {
        collection.push({
            categoryId: item.l3CategoryId,
            categoryLabel: item.l3CategoryLabel,
            categoryName: item.l3CategoryName,
            categoryUrl: item.l3CategoryUrl
        });
    }

    if (item.l4CategoryId) {
        collection.push({
            categoryId: item.l4CategoryId,
            categoryLabel: item.l4CategoryLabel,
            categoryName: item.l4CategoryName,
            categoryUrl: item.l4CategoryUrl
        });
    }

    return collection;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/categoryGrabber.js
// module id = Gd4V
// module chunks = 46